import { Pipe, PipeTransform } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { isSomething } from '../functions'

@Pipe({
  name: 'isFiltering',
  pure: false,
  standalone: false,
})
export class IsFilteringPipe implements PipeTransform {
  transform(form: UntypedFormGroup, ignoreFields: string[] = [], defaultEmptyValues = ['all']): boolean {
    const data = form.value
    return Object.keys(data).some(
      (key) => !ignoreFields.includes(key) && !defaultEmptyValues.includes(data[key]) && isSomething(data[key])
    )
  }
}
